import { render, staticRenderFns } from "./ProductContentDashboard.vue?vue&type=template&id=1f6ea24c&scoped=true&"
import script from "./ProductContentDashboard.vue?vue&type=script&lang=js&"
export * from "./ProductContentDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ProductContentDashboard.vue?vue&type=style&index=0&id=1f6ea24c&prod&lang=css&"
import style1 from "./ProductContentDashboard.vue?vue&type=style&index=1&id=1f6ea24c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6ea24c",
  null
  
)

export default component.exports